import React from 'react';
import {faqButton} from 'app/utils';

const NoGiftMessage = props => <div>
    <div className="simple-popup__text">{props.message} {faqButton(props.faqPath)}</div>
</div>;

export default NoGiftMessage;
